import React, { useState } from "react";
import ResetForm from "../molecules/ResetForm";
import MessageConfirmation from "../molecules/MessageConfirmation";
import AuthLayout from "./AuthLayout";

const ResetPassword = () => {
  const [check, setCheck] = useState(false);
  const [mail, setMail] = useState("");

  return (
    <AuthLayout>
      {!check
        ? <ResetForm setCheck={setCheck} setMail={setMail} dark />
        : <MessageConfirmation mail={mail} dark />
      }
    </AuthLayout>
  );
};

export default ResetPassword;
